// extracted by mini-css-extract-plugin
module.exports = {"header":"guessheader_header__35E6j","title":"guessheader_title__10-eA","wrapper":"guessheader_wrapper__3-VKb","activelist":"guessheader_activelist__3Un0d"};